import { useContext } from 'react';
import { SplitDataContext } from '.';

export const useSplitData = () => {
  const context = useContext(SplitDataContext);

  return context;
};
